
export const common = {
  // Header
  "site_title": "Davetiye Kayıt Sistemi",
  "site_subtitle": "rsvp.ion.global",
  
  // Form
  "event_registration_form": "Etkinlik Katılım Formu",
  "form_description": "Lütfen adınızı ve katılım durumunuzu belirtiniz.",
  "full_name": "Ad Soyad",
  "full_name_placeholder": "Adınızı ve soyadınızı giriniz",
  "participation_question": "Katılım Durumu",
  "yes_participate": "Evet, katılacağım",
  "no_participate": "Hayır, katılmayacağım",
  
  // Buttons
  "confirm_rsvp": "Kaydımı Teyit Et",
  "submitting": "Kaydediliyor...",
  
  // Messages
  "registration_success": "Kayıt Başarılı!",
  "registration_success_message": "Katılımınız başarıyla kaydedildi. Teşekkür ederiz!",
  "registration_error": "Kayıt Hatası",
  "registration_error_message": "Bir hata oluştu. Lütfen tekrar deneyiniz.",
  
  // Validation
  "name_required": "Lütfen adınızı ve soyadınızı giriniz.",
  "participation_required": "Lütfen katılım durumunuzu seçiniz.",
  
  // Footer
  "copyright": "© 2025 rsvp.ion.global - Tüm hakları saklıdır.",
  "powered_by": "Powered by ion.global"
};

export default common;
